import { render, staticRenderFns } from "./AdminPanelAdminsEdit.vue?vue&type=template&id=8cb05dc6&"
import script from "./AdminPanelAdminsEdit.vue?vue&type=script&lang=js&"
export * from "./AdminPanelAdminsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports